import { Component, OnInit } from "@angular/core";
import { CompaniesService } from "./companies.service";

@Component({
  selector: "create-company",
  template: require('./createcompany.component.html'),
  styles: [require('./createcompany.component.scss')]
})
export class CreateCompanyComponent implements OnInit {
  activePanels = ["details"];
  sent: boolean;
  company = {};

  constructor(private service: CompaniesService) {}

  ngOnInit() {}

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      if (!this.sent) {
        this.sent = true;
        this.service.createCompany(this.company).subscribe(
          (response) => {
            this.sent = false;
            this.back();
          },
          (error) => {
            this.activePanels = ["details"];
            this.sent = false;
          }
        );
      }
    }, 1);
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/companies/createcompany.component.ts